import React, { useState, useMemo, useEffect } from 'react';
import {
  AFPTable,
  EmptyState,
  useModal,
  FlexView,
} from '@gsa/afp-component-library';
import {
  EDIT_ACTION,
  DELETE_ACTION,
  getColorColumns,
  getColorsReadOnlyColumns,
} from './colors-table-defs';
import AddColor from './add-color';
import DeleteColorModal from './delete-color-modal';
import { useContractLine } from '../provider/contract-line-provider';

const ColorsTab = () => {
  const [selectedColor, setSelectedColor] = useState(null);
  const { isOpen, openModal, closeModal } = useModal();
  const [showEdit, setShowEdit] = useState(false);

  const {
    contractLine,
    gsaColors,
    colorsTabData,
    setColorsTabData,
    setAlert,
    canUpdateContract,
    canVendorUpdateContract,
  } = useContractLine();

  const canUpdateColor = canUpdateContract || canVendorUpdateContract;

  useEffect(() => {
    if (colorsTabData === null && contractLine?.modelColors?.length > 0) {
      setColorsTabData(contractLine.modelColors);
    }
  }, [contractLine?.modelColors]);

  const colors = colorsTabData || [];

  const onActionClick = (action, { original }) => {
    setSelectedColor(original);
    setAlert(null);
    if (action === DELETE_ACTION) openModal();
    else if (action === EDIT_ACTION) setShowEdit(true);
  };

  const columns = useMemo(() => {
    if (canUpdateColor) {
      return getColorColumns(onActionClick, gsaColors);
    }

    return getColorsReadOnlyColumns(gsaColors);
  }, [canUpdateColor, gsaColors]);

  return (
    <FlexView column className="margin-top-6">
      <div>
        <span className="title-m-bold margin-bottom-4">Colors</span>
      </div>
      {canUpdateColor && (
        <AddColor
          selectedColor={selectedColor}
          showEdit={showEdit}
          setShowEdit={setShowEdit}
        />
      )}
      <AFPTable
        fullWidth
        columns={columns}
        data={colors}
        defaultSort={[['vendorColorName', 'asc']]}
      />
      {!colors.length && (
        <div className="table-empty-state">
          <EmptyState bottomText="Add colors to the table" />
        </div>
      )}
      {isOpen && selectedColor && (
        <DeleteColorModal color={selectedColor} onClose={closeModal} />
      )}
    </FlexView>
  );
};

ColorsTab.propTypes = {};

export default ColorsTab;
